import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { dashboardColors } from "routes/utils";

// Initialize drilldown module

interface StackedDrilldownChartProps {
  data: any;         // API response
  isFetching: boolean;
}

const StackedDrilldownChart: React.FC<StackedDrilldownChartProps> = ({ data, isFetching }) => {
  if (isFetching) {
    return <p>Loading chart data...</p>;
  }

  // Extract series data from API
  const mainSeries = ((data?.purchaseSeriesData!=null)?data?.purchaseSeriesData:[]) || []; 
  const drilldownSeries = ((data?.purchaseDrillDownData!=null)?data?.purchaseDrillDownData:[]) || [];
  const colors = dashboardColors ;

  const options: Highcharts.Options = {
    chart: { type: "column" },
    title: { text: "Stacked Drilldown" },
     xAxis: {
    type: "category",
    labels: {
      useHTML: true,
      formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
        return this.value as string; // ✅ Properly typed
      },
    },
  },
   
    yAxis: {
      title: { text: "Total Count" },
      stackLabels: { enabled: true },
    },
    tooltip: {
      shared: true,
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} kg</b><br/>',
    },
    credits: {
  enabled: false,
},
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: { enabled: true, format: "{point.y} kg" },
      },
    },
    colors,
    series: mainSeries.map((s: any) => ({
      type: s.type,
      name: s.name,
      data: s.data.map((d: any) => ({
        name: d.name,
        y: d.y,
        drilldown: d.drilldown,
      })),
    })),
    drilldown: {
      series: drilldownSeries
      // drilldownSeries.map((d: any) => ({
      //   id: d.id,
      //   name: d.name,
      //   type: d.type,
      //   stack: d.stack,
      //   data: d.data.map((dd: any) => [dd.name, dd.y]),
      // })),
    },
  };


  return (
    <div style={{ width: "100%", maxWidth: 700, margin: "0 auto" }}>
      <h2>Purchase / Unloading </h2>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default StackedDrilldownChart;
